<script>
    import { closeAllModals, openModal } from "svelte-modals";
    import ImageModal from "../../Modal/ImageModal.svelte";
    import ImageUploadModal from "../../Modal/ImageUploadModal.svelte";

    export let fieldName;
    export let id;

    //Object of Image
    export let image;

    export let errorText;

    function addImage() {
        openModal(ImageUploadModal, {
            title: "Inserisci immagine",
            onConfirm: (newImage) => {
                closeAllModals();
                image = newImage;
                console.log(image)
            }
        })
    }

    function editImage(currentImage) {
        openModal(ImageUploadModal, {
            title: "Modifica immagine",
            image: currentImage,
            onConfirm: (newImage) => {
                closeAllModals();
                image = newImage;
            }
        })
    }

    function showImage(currentImage) {
        openModal(ImageModal, {
            image: currentImage,
        })
    }
</script>

<div class="flex flex-col w-full h-full">
    {#if !!fieldName}
        <label for={id} class="font-450 text-lg">{fieldName}</label>
    {/if}

    <div class="flex items-center justify-center image-container bg-gray-100 p-2">
        <div class="flex items-center justify-center w-8/12 aspect-9-16 md:w-1/2 bg-gray-50 relative p-1">
            <div class="absolute flex w-full h-full appear-on-hover">
                {#if !!image}
                    <button type="button" class="flex-grow h-full flex items-center justify-center focus:outline-none text-warning" on:click={() => editImage(image)}>
                        <i class="fas fa-pen text-3xl"></i>
                    </button>
                    <button type="button" class="flex-grow h-full flex items-center justify-center focus:outline-none text-lightBlue-400" on:click={() => showImage(image)}>
                        <i class="fas fa-eye text-3xl"></i>
                    </button>
                {:else}
                    <button type="button" class="flex-grow h-full flex items-center justify-center focus:outline-none" on:click={() => addImage()}>
                        <i class="fas fa-plus text-3xl"></i>
                    </button>
                {/if}
            </div>

            {#if !!image}
                <img src={image.link} class="object-cover h-full" alt="{image.originalName}" />
            {/if}
        </div>
    </div>

    {#if errorText}
        <div class="pl-3 text-red-500">
            {errorText}
        </div>
    {/if}
</div>

<style>
    .image-container {
        display: flex;
        flex-grow: 1;
    }

    .aspect-9-16 {
        aspect-ratio: 16/9;
    }

    .appear-on-hover {
        opacity: 0;
        transition-duration: 200ms;
    }

    .appear-on-hover:hover {
        opacity: 100;
    }
</style>